import axios from 'axios'

const urlBase = 'https://3gyavaw5tj.execute-api.us-west-1.amazonaws.com/desa/api'
const urlBaseCIA = 'https://i71xu8cd55.execute-api.us-west-1.amazonaws.com/desa/api'
const urlBaseExt = 'https://3a9vv5mgli.execute-api.us-west-1.amazonaws.com/desa/api'

/**
 * @param {string}  url url a la cual consultar
 * esta funcion detecta si es una nueva url base (comienza con http:// o https://).
 * en caso de ser asi, retorna la url. en caso contrario, se asume que es un fragmento
 * de path por lo que se concatena con la constante urlBase
 **/
const readUrl = (url = '') =>
    url.startsWith('http://') || url.startsWith('https://') ? url : `${urlBase}/${url}`;

const readUrlCIA = (url = '') =>
    url.startsWith('http://') || url.startsWith('https://') ? url : `${urlBaseCIA}/${url}`;

const readUrlExt = (url = '') =>
    url.startsWith('http://') || url.startsWith('https://') ? url : `${urlBaseExt}/${url}`;
/**
 * Instancia personalizada de axios para agregar interceptores 
 */
const instance = axios.create();

const get = (url = '', headers = {}) => instance.get(readUrl(url), {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers
    }
})

const post = (url = '', body = {}, headers = {}) => instance.post(readUrl(url), body, {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers
    }
})

const put = (url = '', body = {}, headers = {}) => instance.put(readUrl(url), body, {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers
    }
})

const del = (url = '', headers = {}) => instance.delete(readUrl(url), {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers
    }
})
const getExt = (url = '', headers = {}) => instance.get(readUrlExt(url), {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers
    }
})
const postLogin = (url = '', body = {}, headers = {}) => instance.post(readUrlCIA(url), body, {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers
    }
})
const client = {
    instance: instance,
    get: get,
    post: post,
    put: put,
    delete: del,
    getExt: getExt,
    postLogin: postLogin
}

export default client;